import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", to: "/" },
  { label: "What We Do", to: "/what-we-do" },
  { label: "Who We Serve", to: "/who-we-serve" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const linkCls = ({ isActive }) =>
  `text-sm font-medium transition-colors hover:text-[#B08D3F] ${
    isActive ? "text-[#B08D3F]" : "text-[#1F2D4E]"
  }`;

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-[#E4E7EC] bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" data-testid="header-logo" aria-label="Reform Intelligence home">
          <img src="/assets/logo-wordmark-navy.webp" alt="Reform Intelligence®" className="h-12 w-auto sm:h-14" />
        </Link>
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className={linkCls}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-request-briefing"
            className="bg-[#1F2D4E] px-5 py-2.5 text-sm font-semibold uppercase tracking-[0.1em] text-white transition-colors hover:bg-[#B08D3F]"
          >
            Request a briefing
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="text-[#1F2D4E] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <nav className="border-t border-[#E4E7EC] bg-white px-5 py-6 lg:hidden" aria-label="Mobile">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} className={linkCls}>
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="bg-[#1F2D4E] px-5 py-3 text-center text-sm font-semibold uppercase tracking-[0.1em] text-white"
            >
              Request a briefing
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
